import * as React from 'react';
import {closeDialog, showCustomDialog , Button ,showPlainDialog , Util } from 'baziigram'
import {showLoginDialog} from "../../pages/Login"
import {dictionary} from "../../constants"
import {lifeStoneDictionary} from "../../constants/lifeStone.js"

export  const showHelp=(action)=>{
const language = Util.getLanguage();
const dir = language=="fa" ? "rtl text-right" : "ltr text-left"
 let body = <div id={"help"} className={`${dir} d-flex text-dark p-3 flex-column align-items-center justify-content-between`}>
      <div id={"help-text"} style={{lineHeight:"30px"}} className={"text-right my-2"}>
      <div className={"d-flex flex-row justify-content-between w-100"}>
              <button
                  type="button"
                  className="close"
                  onClick={action}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
        <h2 className={" text-center"}>{dictionary.phoenixAndLifeStone[language]}</h2>
        <div className={dir} dangerouslySetInnerHTML={{__html: lifeStoneDictionary.baziigramStoryTxt[language]}} />

        <img alt="war" src={"/images/main-page/war.jpg"} width={"95%"}
             style={{display:"block" , margin:"auto" , borderRadius:"8px" , maxWidth:"350px"}}/>
    </div>
      <div id={"buttons"}>

       <Button onClick={action} title={dictionary.start[language]}></Button>
     </div>
    </div>

    showCustomDialog(body)

}

export const openForgetDialog = (text)=>{
const language = Util.getLanguage();
  let action = {title:dictionary.loginBtn[language],
  onClick:()=>{closeDialog();showLoginDialog();}
  }
  let msg = <div className={"text-center"}>{dictionary.dearFriend[language]}<br/>
                  <div dangerouslySetInnerHTML={{__html: dictionary[text][language]}} />
                  </div>
  showPlainDialog(msg, "" , "/images/main-page/forget.png" , action)
  }

export const showDailyCoinDialog = (coin )=>{
 const language = Util.getLanguage();
 let title = <div className="text-warning">
 {coin + " " + dictionary.dailyawardTitle[language]}
 </div>
  showPlainDialog(dictionary.dailyAwardMessage[language],
   title , "/images/icons/coin2.png" )

  }

